
import Vue from 'vue'
import RealTransformer from '@/transformers/workPlan/real'

export default (opts={}) => {
  let url = 'workplan/real/'
  const { residentId, id, finished, cancelToken, dateStart, dateUntil } = opts 

  if (id) {
    url += `${id}/`
  } else if ( residentId ) {
   url += `resident/${residentId}/`
  }

  const params = {
    finished: finished ? finished : undefined,
    // :TODO: Remove filtering
    date_start: dateStart ? dateStart : undefined,
    date_until: dateUntil ? dateUntil : undefined,
  }

  return Vue.$http.get(url, { params, cancelToken })
    .then(response => {

      try {

        let data

        if (!id) {
          data = RealTransformer.fetchCollection(response.data)
            .sort((a, b) => a.startDate - b.startDate)
        } else {
          data = RealTransformer.fetch(response.data)
        }

        return data
      } catch (err) {
        throw err
      }
      
    })
}



// WEBPACK FOOTER //
// ./src/services/workPlan/fetchReal.js